import styles from './styles';
import CardContent from '@material-ui/core/CardContent';
import CardHeader from '@material-ui/core/CardHeader';
import C3Chart from 'react-c3js';
import Card from '@material-ui/core/Card';
import React from 'react';

const OverallProgress = ({ job, data }) => {
  return (<Card style={styles.card}>
    <CardHeader title="Overall Progress"/>
    <CardContent>
      {data ? <C3Chart
        data={data.data}
        color={data.color}
        size={{ height: 320 }}/> : <div>No Data</div>}
    </CardContent>
  </Card>);
};

export default OverallProgress;



// WEBPACK FOOTER //
// ./src/components/Reports/JobReport/OverallProgress.js